
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired966"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired966"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("gzPnL");
const $e0f06e52da8f2c55$var$initGame = ()=>{
    const gameState = [];
    const questionWrapper = document.getElementById("question-wrapper");
    const indicator = document.getElementById("indicator");
    const results = document.getElementById("results");
    const successText = Array.from(document.getElementsByClassName("success-text"));
    const failText = Array.from(document.getElementsByClassName("fail-text"));
    const resultsBackButton = document.getElementById("results-back");
    if (!questionWrapper || !indicator || !results || !successText || !failText || !resultsBackButton) return;
    const questions = Array.from(questionWrapper.querySelectorAll(".question"));
    if (questions.length === 0) return;
    const animateTo = (index)=>{
        const distance = 100 * index;
        for (const question of questions)question.style.transform = `translateX(-${distance}%)`;
        results.style.transform = `translateX(-${distance}%)`;
        if (gameState.length < questions.length) {
            indicator.style.transform = `translateX(${distance}%)`;
            setTimeout(()=>{
                for (const text of successText)text.style.display = "none";
                for (const text of failText)text.style.display = "none";
            }, 500);
        } else {
            indicator.style.transform = `translateX(0%) scaleX(${100 * questions.length}%)`;
            const totalPoints = gameState.reduce((a, b)=>a + b, 0);
            if (totalPoints >= 2) for (const text of successText)text.style.display = "block";
            else for (const text of failText)text.style.display = "block";
        }
    };
    const addAnswer = (index, points)=>{
        if (gameState[index]) return;
        gameState[index] = points;
        animateTo(index + 1);
    };
    const removeAnswer = (index)=>{
        gameState.splice(index - 1);
        animateTo(index - 1);
    };
    for (const [index, question] of questions.entries()){
        const buttons = Array.from(question.querySelectorAll("button.answer"));
        if (buttons.length === 0) return;
        for (const button of buttons)button.addEventListener("click", (e)=>{
            if (gameState.length > index) return;
            const points = Number(button.dataset.points);
            if (isNaN(points)) return;
            addAnswer(index, points);
        });
        const backButton = question.querySelector("button.back");
        if (!backButton) continue;
        backButton.addEventListener("click", (e)=>{
            removeAnswer(index);
        });
    }
    resultsBackButton.addEventListener("click", (e)=>{
        removeAnswer(questions.length);
    });
};
$e0f06e52da8f2c55$var$initGame();
const $e0f06e52da8f2c55$var$toQuickCheckButton = document.getElementById("to-quick-check");
const $e0f06e52da8f2c55$var$hero = document.getElementById("hero");
// tell parent to scroll to quick check
$e0f06e52da8f2c55$var$toQuickCheckButton?.addEventListener("click", ()=>{
    if (!$e0f06e52da8f2c55$var$hero) return;
    const heroStyles = window.getComputedStyle($e0f06e52da8f2c55$var$hero);
    const height = $e0f06e52da8f2c55$var$hero?.clientHeight + parseInt(heroStyles.marginBottom) || 0;
    window.parent.postMessage(`quick-check-scroll:${height}`, "*");
});
const $e0f06e52da8f2c55$var$toConsultationButton = document.getElementById("to-consultation");
$e0f06e52da8f2c55$var$toConsultationButton?.addEventListener("click", (e)=>{
    window.parent.postMessage("sc23:button-clicked:Zur-Beratung", "*");
});


//# sourceMappingURL=top.18c3d5ae.js.map
